export default {
  'picky-cats:journey:food-type:wet_food:label': 'Nassfutter',
  'picky-cats:journey:food-type:dry_food:label': 'Trockenfutter',
  'picky-cats:journey:food-type:snacks:label': 'Snacks',

  'picky-cats:journey:consistency:sauce:label': 'Sauce',
  'picky-cats:journey:consistency:sauce:detail': 'Saucen Menü, Juicy Filet',
  'picky-cats:journey:consistency:pate:label': 'Pate',
  'picky-cats:journey:consistency:pate:detail': 'Pure Meat, Filet Menü, Meaty Pate',
  'picky-cats:journey:consistency:cream:label': 'Creme',
  'picky-cats:journey:consistency:cream:detail': 'Silky Cream',

  'picky-cats:journey:protein:duck:label': 'Ente',
  'picky-cats:journey:protein:poultry:label': 'Geflügel',
  'picky-cats:journey:protein:deer:label': 'Hirsch',
  'picky-cats:journey:protein:chicken:label': 'Huhn',
  'picky-cats:journey:protein:rabbit:label': 'Kaninchen',
  'picky-cats:journey:protein:veal:label': 'Kalb',
  'picky-cats:journey:protein:kangaroo:label': 'Känguru',
  'picky-cats:journey:protein:salmon:label': 'Lachs',
  'picky-cats:journey:protein:turkey:label': 'Pute',
  'picky-cats:journey:protein:tuna:label': 'Thunfisch',
  'picky-cats:journey:protein:game:label': 'Wild',
  'picky-cats:journey:protein:beef:label': 'Rind',
  'picky-cats:journey:protein:pork:label': 'Schwein',
  'picky-cats:journey:protein:horse:label': 'Pferd',

  'picky-cats:journey:age-band:kitten:label': 'Kitten',
  'picky-cats:journey:age-band:kitten:detail': '0–1 Jahr',
  'picky-cats:journey:age-band:adultcat:label': 'Adult',
  'picky-cats:journey:age-band:adultcat:detail': '1–8 Jahre',
  'picky-cats:journey:age-band:seniorcat:label': 'Senior',
  'picky-cats:journey:age-band:seniorcat:detail': 'ab 8 Jahren',

  'picky-cats:journey:cat-count:one:label': 'Nur eine',
  'picky-cats:journey:cat-count:two:label': 'Zwei',
  'picky-cats:journey:cat-count:more-than-two:label': 'Mehr als zwei',
  'picky-cats:journey:cat-count:feedback:V1:one':
    'Alles klar – deine Samtpfote hat ihren Napf ganz für sich allein.',
  'picky-cats:journey:cat-count:feedback:V1:multiple':
    "2+ Katzen: Gut zu wissen! Mehrere Katzen fressen am liebsten aus ihrem eigenen Napf – so gibt's keinen Futterneid.",
  'picky-cats:journey:cat-count:feedback:V2:one':
    'Alles klar – deine Samtpfote hat ihren Napf ganz für sich allein.',
  'picky-cats:journey:cat-count:feedback:V2:multiple':
    "Gut zu wissen! Mehrere Katzen fressen am liebsten aus ihrem eigenen Napf – so gibt's keinen Futterneid.",

  'picky-cats:journey:education:serving-temperature:title': 'Wie servierst du das Futter?',
  'picky-cats:journey:education:serving-temperature:option:refrigerated':
    'Direkt aus dem Kühlschrank',
  'picky-cats:journey:education:serving-temperature:option:room-temperature':
    'Bei Zimmertemperatur',
  'picky-cats:journey:education:serving-temperature:option:warmed': 'Leicht angewärmt',
  'picky-cats:journey:education:serving-temperature:feedback:confirmation':
    'Sehr gut! Bei Zimmertemperatur duftet das Futter am intensivsten – ein Fest für die Katzennase.',
  'picky-cats:journey:education:serving-temperature:feedback:advice':
    'Kleiner Trick: Direkt aus dem Kühlschrank riecht das Futter nach fast nichts. Kurz auf Zimmertemperatur bringen, dann schmeckt’s gleich besser.',

  'picky-cats:journey:education:bowl-shape:title': 'Aus was für einem Napf frisst deine Katze?',
  'picky-cats:journey:education:bowl-shape:option:deep-narrow': 'Tief & schmal',
  'picky-cats:journey:education:bowl-shape:option:flat-wide': 'Flach & weit',
  'picky-cats:journey:education:bowl-shape:option:unsure': 'Nicht sicher',
  'picky-cats:journey:education:bowl-shape:feedback:V1:confirmation':
    "Stark! Ein flacher, weiter Napf ist genau richtig. Tipp obendrauf: An einem ruhigen Ort schmeckt's ihr gleich noch besser.",
  'picky-cats:journey:education:bowl-shape:feedback:V1:advice':
    "Kleiner Trick: Katzen mögen's flach und weit – in tiefen Näpfen stoßen die empfindlichen Schnurrhaare an. Und stell den Napf an ein ruhiges Plätzchen.",
  'picky-cats:journey:education:bowl-shape:feedback:V2:confirmation':
    'Stark! Ein flacher, weiter Napf ist genau richtig.',
  'picky-cats:journey:education:bowl-shape:feedback:V2:advice':
    "Kleiner Trick: Katzen mögen's flach und weit – in tiefen Näpfen stoßen die empfindlichen Schnurrhaare an.",

  'picky-cats:journey:education:feeding-frequency:title': 'Wie oft frisst deine Katze am Tag?',
  'picky-cats:journey:education:feeding-frequency:option:once': '1x am Tag',
  'picky-cats:journey:education:feeding-frequency:option:two-plus': '2 oder mehr Mahlzeiten',
  'picky-cats:journey:education:feeding-frequency:option:always-available': 'Immer verfügbar',
  'picky-cats:journey:education:feeding-frequency:feedback:confirmation':
    'Genau so! Mehrere kleine Mahlzeiten passen perfekt zum natürlichen Rhythmus deiner Katze.',
  'picky-cats:journey:education:feeding-frequency:feedback:advice':
    'Kleiner Trick: In der Natur macht deine Katze viele kleine Beutezüge. Zwei oder mehr feste Mahlzeiten am Tag tun ihr richtig gut.',

  'picky-cats:journey:education:bowl-location:title': 'Wo steht der Futternapf?',
  'picky-cats:journey:education:bowl-location:option:near-litter': 'Nähe Katzenklo / Mülleimer',
  'picky-cats:journey:education:bowl-location:option:busy-spot': 'An belebter Stelle',
  'picky-cats:journey:education:bowl-location:option:quiet-spot': 'Ruhig & entspannt',
  'picky-cats:journey:education:bowl-location:feedback:confirmation':
    'Perfekt! An einem ruhigen Ort fühlt sich deine Katze sicher – und frisst gleich viel lieber.',
  'picky-cats:journey:education:bowl-location:feedback:advice':
    'Kleiner Trick: Neben Katzenklo oder im Trubel schmeckt’s nur halb so gut. Ein ruhiges Plätzchen für den Napf wirkt Wunder.',

  'picky-cats:journey:tip:bowl:text': 'Flacher, weiter Napf – so bleiben die Schnurrhaare frei.',
  'picky-cats:journey:tip:bowl-location:text':
    'Flacher, weiter Napf an einem ruhigen Ort – so frisst deine Katze am liebsten.',
  'picky-cats:journey:tip:calm-location:text': 'Ruhiger Futterplatz, weg von Klo und Trubel.',
  'picky-cats:journey:tip:frequency:text': 'Zwei oder mehr feste Mahlzeiten am Tag.',
  'picky-cats:journey:tip:temperature:text': 'Futter auf Zimmertemperatur bringen.',
  'picky-cats:journey:tip:separate-bowls:text': 'Jede Katze braucht ihren eigenen Napf.',

  'picky-cats:journey:result:V1:heading': 'Profil fertig!',
  'picky-cats:journey:result:V1:detail':
    'Wir haben jetzt das Profil deiner wählerischen Katze – und helfen dir, das passende Futter zu finden.',
  'picky-cats:journey:result:V1:praise': 'Du machst schon alles richtig!',
  'picky-cats:journey:result:V3:heading': 'Das Profil deiner wählerischen Katze steht!',
  'picky-cats:journey:result:V3:detail':
    'Wählerische Katzen brauchen zwei Dinge: richtig gefüttert zu werden – und das Futter, das ihnen wirklich schmeckt. Beides haben wir für deine Katze zusammengestellt.',
  'picky-cats:journey:result:V3:praise': 'Du fütterst schon alles richtig!',
  'picky-cats:journey:result:tips:heading': 'So fütterst du deine Katze noch besser',
  'picky-cats:journey:result:products:heading': 'Unsere Empfehlungen für deine Katze',
  'picky-cats:journey:result:recommendation:error':
    'Deine Empfehlungen konnten nicht geladen werden.',
  'picky-cats:journey:result:recommendation:retry': 'Erneut versuchen',
  'picky-cats:journey:result:recommendation:empty':
    'Für diese Auswahl haben wir gerade keine passenden Produkte.',
  'picky-cats:journey:result:cart:add': '{title} in den Warenkorb legen',
  'picky-cats:journey:result:cart:pending': '{title} wird in den Warenkorb gelegt',
  'picky-cats:journey:result:cart:completed': '{title} wurde in den Warenkorb gelegt',
  'picky-cats:journey:result:cart:retry': '{title} erneut in den Warenkorb legen',
  'picky-cats:journey:result:cart:error': 'Hinzufügen fehlgeschlagen. Bitte versuche es erneut.',
  'picky-cats:journey:result:handoff': 'Mehr passendes Futter anzeigen',
  'picky-cats:journey:result:handoff:error': 'Dein Katzenprofil konnte nicht gespeichert werden.',
  'picky-cats:journey:result:handoff:retry': 'Erneut versuchen',

  'picky-cats:journey:result:V2:praise:heading': 'Du fütterst schon alles richtig!',
  'picky-cats:journey:result:V2:praise:detail':
    'Deine Katze ist einfach eine kleine Feinschmeckerin. Dann finden wir jetzt das Futter, das sie überzeugt.',
  'picky-cats:journey:result:V2:tricks:heading': 'Wir haben ein paar schnelle Tricks für dich!',
  'picky-cats:journey:result:V2:action:continue': 'Jetzt Empfehlung starten',
  'picky-cats:journey:result:V2:action:close': 'Verstanden',

  'picky-cats:journey:recommendation:V2:heading': 'Fertig – das Profil deiner Katze steht!',
  'picky-cats:journey:recommendation:V2:detail':
    'Wir haben aus deinen Angaben ein Profil für deine wählerische Katze erstellt und das passende Futter herausgesucht.',
  'picky-cats:journey:recommendation:V2:cart:label': 'In den Warenkorb',
  'picky-cats:journey:recommendation:V2:cart:completed-label': 'Hinzugefügt',
  'picky-cats:journey:recommendation:V2:cart:retry-label': 'Erneut versuchen',
};
